import { createSelector } from "reselect"
import { get, first, last, chain, filter, isEmpty } from "lodash"
import { getStartDate, getEndDate } from "modules/security-profile/selectors/dates"
import { createIntradaySelector } from "modules/security-profile/selectors/intraday"
import { toIsoDate } from "helpers/dates"

const EMPTY_OBJECT = {}

const getRawFactorSensitivity = createIntradaySelector(
  "global.data.securityFactorSensitivity.data.model.simulation.factorSensitivity",
  "global.data.securityFactorSensitivity.data.model.intradaySimulation.factorSensitivity",
  EMPTY_OBJECT,
  EMPTY_OBJECT,
)
export const getFactorSensitivityType = (_, props) => get(props, "factorSensitivityType")
export const getOnly = state => get(state, "modules.securityProfileFactorSensitivity.only")

function formatFactorSensitivity(sensitivity) {
  return chain(sensitivity)
    .filter(item => !isEmpty(item.factors))
    .map(({ date, factors }) => ({
      date,
      factors: chain(factors)
        .keyBy("id")
        .mapValues(({ sensitivity }) => sensitivity * 100)
        .value(),
    }))
    .value()
}

export const getFactorSensitivity = createSelector(
  [getRawFactorSensitivity],
  formatFactorSensitivity,
)

export const getFilteredFactorSensitivity = createSelector(
  [getFactorSensitivity, getStartDate, getEndDate],
  (sensitivity, startDate, endDate) => filter(sensitivity, data => toIsoDate(data.date) >= startDate && toIsoDate(data.date) <= endDate),
)

export const getFirst = createSelector(
  [getFactorSensitivity],
  first,
)

export const getCurrent = createSelector(
  [getFactorSensitivity],
  last,
)

export const getFirstFactorSensitivityDate = createSelector(
  [getFilteredFactorSensitivity],
  (sensitivity) => toIsoDate(chain(sensitivity)
    .first()
    .get("date", null)
    .value()),
)
